import { Component } from '@angular/core';

@Component({
    templateUrl: './notification-drawer.component.html',
    standalone: false,
})
export class NotificationDrawerComponent {}
